import BossModel from "@/models/BossModel";
import Product from '@/models/Product/Product'
import Package from '@/models/Package/Package'

export default class Line extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'package/line';

    /**
     *
     * @type {string}
     */
    static entity = 'packageLines';

    static fields() {
        return {
            id: this.number(null).nullable(),
            package_id: this.number(null).nullable(),
            product_id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            sort_order: this.number(null).nullable(),
            start_day_in_period: this.number(null).nullable(),
            end_day_in_period: this.number(null).nullable(),
            is_optional: this.boolean(null),
            is_active: this.boolean(null),
            is_flight_international: this.boolean(null),
            flight_group: this.number(null).nullable(),
            product: this.belongsTo(Product, 'product_id'),
            package: this.belongsTo(Package, 'package_id'),
        }
    }

    /**
     *
     * @returns {boolean}
     */
    IsRenewable(){
        return this.id == this.Package().renewable_package_product_id;
    }

    /**
     *
     * @returns {boolean|*}
     */
    Product(){
        return this.getRelated('product');
    }

    Package(){
        return this.getRelated('package');
    }
}
